<template>
  <fin-editable-list
    class="fin-screener-editable-list"
    v-model="model"
    :create-btn-text="createBtnText"
    :create-item="createScreener"
    :description="description"
    :img="img"
    :img-max-width="275"
    :img-style="$vuetify.breakpoint.smAndUp ? 'margin-top: -120px;' : ''"
    :noData="noData"
    :prompt="createPrompt"
    :title="title"
    :update-item-name="updateScreenerName"
    dialog-btn="Umbenennen"
    dialog-textfield-label="Screener Name"
    dialog-title="Screener umbennen"
    title-clickable
    @titleClicked="(val) => model.find(sc => sc.id === val).inactive !== true ? $router.push({name: $route.fullPath.endsWith('/shareScreener') ? 'shareScreenerExecute' : 'etfScreenerExecute', params: {id: val}}) : ''"
    :check-if-prompt-allowed="checkSubscription"
    :not-allowed-action="showSubscriptionDialog"
  >
    <template #item-subline="{item}">
      <div v-if="item.lastHits">
        <span>{{ item.lastHits }} Ergebnisse </span>
        <fin-time-ago :datetime="item.lastHitsUpdated" class="last-hits__date"/>
      </div>
    </template>

    <template #icon v-if="!checkSubscription()">
      <fin-subscription-lock/>
    </template>

    <template #context-actions="{item}">
      <v-btn :color="$finColors.primaryDark" class="btnStartTool"
             text
             tile
             :disabled="item.inactive"
             @click="$emit('execute', item)">
        Screener anwenden
      </v-btn>
      <v-btn :color="$finColors.primaryDark"
             class="btnEdit"
             outlined
             text
             tile
             :disabled="item.inactive"
             @click="$emit('edit', item)">
        Bearbeiten
      </v-btn>
    </template>

    <template #context-menu="{item, showRename}">
      <v-list-item v-if="updateScreenerName" :disabled="item.inactive" @click="showRename(item)">
        <v-list-item-title>
          Umbenennen
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="deleteScreener" @click="startDeleteScreener(item)">
        <v-list-item-title>
          Löschen
        </v-list-item-title>
      </v-list-item>
    </template>
  </fin-editable-list>
</template>

<script>
import FinEditableList from '@/components/common/EditableList/index'
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"
import PriceModel from "@/mixins/PriceModel"
import {EventBus} from "@/plugins/fincraft"
import FinSubscriptionLock from "@/components/common/subscription/lock"

export default {
  name: 'FinScreenerList',
  components: {FinSubscriptionLock, FinEditableList},
  props: {
    value: {
      type: Array
    },
    noData: {
      type: String,
      default: 'Du hast noch keinen eigenen Screener angelegt.'
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    createBtnText: {
      type: String,
      default: 'Neuer Screener'
    },
    updateScreenerName: {
      type: Function
    },
    createScreener: {
      type: Function
    },
    deleteScreener: {
      type: Function
    }
  },
  data: () => {
    return {
      img: require('@/assets/watchlist/watchlist.svg'),
      createPrompt: {
        title: 'Wie soll dein Screener heißen?',
        dialogWidth: 448,
        confirmBtn: 'Speichern',
        input: true,
        inputText: '',
        inputLabel: 'Name deines Screeners',
        textBelow: 'Du findest den Screener in deinen Tools und kannst ihn jederzeit anwenden.'
      },
    }
  },
  mixins: [PriceModel],
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit("input", newVal)
      }
    }
  },
  methods: {
    startDeleteScreener(screener) {
      this.$confirm({
        title: 'Screener löschen',
        text: `Möchtest du den Screener "${screener.name}" wirklich löschen?`,
        dialogWidth: 448,
        confirmBtn: 'Löschen'
      })
        .then(() => {
          this.deleteScreener(screener)
            .then(() => {
              // Todo loading state in dialog
              const copy = [...this.value]
              copy.splice(copy.indexOf(screener), 1)
              this.$emit('input', copy)
            })
            .catch(() => {

            })
        })
    },
    checkSubscription() {
      return this.isPriceModelFeatureEnabled(this.$route.fullPath.includes('/shareScreener') ? PRICEMODEL_FEATURE_IDS.SHARE_SCREENER.id : PRICEMODEL_FEATURE_IDS.ETF_SCREENER.id)
    },
    showSubscriptionDialog() {
      EventBus.$emit(
        'showSubscriptionPopup',
        this.$route.fullPath.includes('/shareScreener') ? PRICEMODEL_FEATURE_IDS.SHARE_SCREENER.id : PRICEMODEL_FEATURE_IDS.ETF_SCREENER.id,
        PRICEMODEL_FEATURE_RESTRICTIONS.UNAVAILABLE)
    },
  },
}
</script>

<style lang="scss" scoped>
.heading {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0;
}

.name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}

.result {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 0;
  color: $fin-color-cool-grey;
}

.creator {
  font-size: 12px;
  font-weight: 600;
  color: $fin-color-cool-grey;
}

.btnEdit {
  border: 2px solid $fin-color-primary-dark !important;
  font-weight: bold;
  font-size: 12px;
}

::v-deep .v-list-item button {
  width: 100%;

  .v-btn__content {
    justify-content: left;
  }
}

.last-hits__date {
  display: inline-flex;

  &::after {
    content: ")";
  }

  &::before {
    content: "(";
  }
}
</style>
